<template>
  <div id="custom-table-list" class="custom-table-container">
    <vs-card>
      <div slot="header">
        <h3>Notícias Destacadas</h3>
      </div>
      
      <div>
        <vs-table
          ref="highlitedTable"
          noDataText="Nenhuma notícia em destaque"
          :data="highlightedNews"
        >
          <template slot="thead">
            <vs-th
              v-for="(tableHeader, index) in tableHeaders"
              :sort-key="tableHeader.sortKey"
              :key="`highlitedTableHeader${index}`"
            >
              {{ tableHeader.text }}
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td>
                  <p class="product-headline font-medium">{{ tr.headline }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category font-medium">{{ tr.category.name }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category font-medium">{{ tr.expanded_qty }}x</p>
                </vs-td>

                <vs-td>
                  <p class="font-medium">
                    {{ formatStringDate(tr.created_at) }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="font-medium">
                    {{ formatStringDate(tr.updated_at) }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-activated font-medium">
                    <ActiveItem :active="tr.activated" />
                  </p>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editData(tr.id)"
                  />

                  <vx-tooltip text="Remover notícia dos destaques">
                    <feather-icon
                      icon="BookmarkIcon"
                      svgClasses="w-5 h-5 fill-current text-warning hover:text-grey ml-3"
                      @click.stop="highlightNews(tr.id, false)"
                    />
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </vs-card>

    <vs-card>
      <div slot="header">
        <h3>Notícias</h3>
      </div>
      
      <div>
        <vs-table
          ref="table"
          :sst="true"
          @sort="handleSort"
          @search="handleSearch"
          noDataText="Nenhuma notícia cadastrada"
          search
          :data="news"
        >
          <!-- HEADER -->
          <div slot="header" id="custom-header-wrapper">
            <HeaderList
              :itemsPerPage="itemsPerPage"
              @changeItemsPerPage="setItemsPerPage"
              @emitAddNewData="addNewData"
            />
          </div>
          <!-- FIM HEADER -->

          <template slot="thead">
            <vs-th
              v-for="(tableHeader, index) in tableHeaders"
              :sort-key="tableHeader.sortKey"
              :key="`tableHeader${index}`"
            >
              {{ tableHeader.text }}
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr v-if="tr !== null" :data="tr" :key="indextr" v-for="(tr, indextr) in data" :state="tr.is_main ? 'warning' : ''">
                <vs-td>
                  <p class="product-headline font-medium">{{ tr.headline }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category font-medium">{{ tr.category.name }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category font-medium">{{ tr.expanded_qty }}x</p>
                </vs-td>

                <vs-td>
                  <p class="font-medium">
                    {{ formatStringDate(tr.created_at) }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="font-medium">
                    {{ formatStringDate(tr.updated_at) }}
                  </p>
                </vs-td>

                <vs-td>
                  <p class="product-activated font-medium">
                    <ActiveItem :active="tr.activated" />
                  </p>
                </vs-td>

                <vs-td class="whitespace-no-wrap">
                  <vx-tooltip v-if="tr.activated" :text="`${tr.is_main ? 'Remover' : 'Tornar'} notícia como principal`">
                  <feather-icon
                    icon="StarIcon"
                    :svgClasses="
                      tr.is_main
                        ? 'w-5 h-5 fill-current text-warning hover:text-grey'
                        : 'w-5 h-5 hover:text-warning stroke-current'
                    "
                    @click.stop="setMainNews(tr.id, tr.is_main, tr.activated)"
                  />
                  </vx-tooltip>

                  <vx-tooltip v-else text="Não é possível tornar uma notícia desativada como principal">
                    <feather-icon
                      icon="StarIcon"
                      svgClasses="w-5 h-5 text-grey stroke-current"
                    />
                  </vx-tooltip>

                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current ml-3"
                    @click.stop="editData(tr.id)"
                  />

                  <vx-tooltip v-if="tr.activated && !tr.is_main" text="Adicionar notícia aos destaques">
                    <feather-icon
                      icon="BookmarkIcon"
                      svgClasses="w-5 h-5 hover:text-warning stroke-current ml-3"
                      @click.stop="highlightNews(tr.id, true)"
                    />
                  </vx-tooltip>

                  <vx-tooltip v-else :text="`Não é possível adicionar uma notícia ${tr.is_main ? 'principal' : 'desativada'} aos destaques`">
                    <feather-icon
                      icon="BookmarkIcon"
                      svgClasses="w-5 h-5 text-grey stroke-current ml-3"
                    />
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <vs-pagination 
          :total="totalPages" 
          v-model="currentPage"
          class="mt-5"
        ></vs-pagination>
      </div>
    </vs-card>
  </div>
</template>

<script>
  import ActiveItem from '@/components/ActiveItem'
  import HeaderList from '@/views/components/custom/HeaderList'

  import moduleNews from '@/store/news/moduleNews'
  import { defineSortFieldDirection, formatDate } from '@/utils'

  export default {
    name: 'news-list',
    components: {
      ActiveItem,
      HeaderList
    },
    data() {
      return {
        selected: [],
        itemsPerPage: 5,
        currentPage: 1,
        isMounted: false,
        sidebarData: {},
        searchField: null,
        alreadyHasMain: false,
        sortField: {
          default: 'id_desc',
          current: '',
          count: 0
        },
        tableHeaders: [
          { sortKey: 'heading', text: 'Título' },
          { sortKey: null, text: 'Caderno' },
          { sortKey: null, text: 'Expandida' },
          { sortKey: null, text: 'Publicada Em' },
          { sortKey: null, text: 'Atualizada Em' },
          { sortKey: null, text: 'Ativo' },
          { sortKey: null, text: 'Ações' },
        ]
      }
    },
    computed: {
      news() {
        return [
          ...[ this.mainNews ],
          ...this.$store.state.news.news
        ]
      },
      highlightedNews() {
        return this.$store.state.news.highlightedNews
      },
      mainNews() {
        return this.$store.state.news.mainNews
      },
      totalPages() {
        return this.$store.state.news.totalPages
      }
    },
    watch: {
      currentPage() {
        this.handleChangePage()
      },
      itemsPerPage() {
        this.handleChangePage()
      }
    },
    methods: {
      addNewData() {
        this.$router.push(`/news/create`)
      },
      editData(newsId) {
        this.$router.push(`/news/edit/${newsId}`)
      },
      highlightNews(newsId, is_highlighted) {
        if (this.highlightedNews.length >= 3 && is_highlighted) {
          return this.$vs.notify({
            title: 'Você já possui 3 notícias em destaque!',
            text: 'Remova alguma notícia do destaque para adicionar outra',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 5000
          })
        }

        this.$store
          .dispatch("news/update", {
            id: newsId,
            is_highlighted
          })
          .then(() => {
            this.fetchHighlightedNews()
            this.fetchData()
          })
          .catch(err => {
            console.error(err);
          });
      },
      setMainNews(newsId, is_main) {
        if (!is_main && this.mainNews !== null) {
          return this.$vs.notify({
            title: 'Você já possui uma notícia principal!',
            text: 'Remova a estrela da notícia principal para adicionar outra',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 5000
          })
        }

        this.$store
          .dispatch("news/update", {
            id: newsId,
            is_main: !is_main
          })
          .then(() => {
            this.fetchMainNews()
            this.fetchData()
          })
          .catch(err => {
            console.error(err);
          });
      },
      setItemsPerPage(qty) {
        this.currentPage = 1
        this.itemsPerPage = qty
        //this.fetchData()
      },
      handleSort(sort) {
        if (sort !== null) {
          this.sortField.count++

          if (this.sortField.count < 3) {
            this.sortField.current = defineSortFieldDirection(this.sortField.current, sort)
          } else {
            this.resetSortField()
          }
          
          this.fetchData()
        } else {
          if (this.sortField.current !== this.sortField.default) {
            this.resetSortField()
            this.fetchData()
          }
        }
      },
      resetSortField() {
        this.sortField.current = this.sortField.default;
        this.sortField.count = 0;
      },
      handleSearch(search) {
        let searchField = null

        if (search !== "") {
          searchField = {
            headline: search
          }
        }
        
        this.searchField = searchField
        this.fetchData()
      },
      handleChangePage() {
        this.fetchData()
      },
      fetchData() {
        if (moduleNews.isRegistered) {
          this.$store.dispatch("news/fetch", {
            is_highlighted: false,
            is_main: false,
            ...this.searchField, 
            ...{ order_by: this.sortField.current },
            ...{ pagination_page: this.currentPage, pagination_limit: this.itemsPerPage }
          })
        }
      },
      fetchHighlightedNews() {
        if (moduleNews.isRegistered) {
          this.$store.dispatch("news/fetchHighlighted", {
            is_highlighted: true,
            order_by: 'id_desc',
            pagination_page: 1,
            pagination_limit: 3
          })
        }
      },
      fetchMainNews() {
        if (moduleNews.isRegistered) {
          this.$store.dispatch("news/fetchMain", {
            is_main: true,
            order_by: 'id_desc',
            pagination_page: 1,
            pagination_limit: 1
          })
        }
      },
      formatStringDate(date) {
        return formatDate(date).full
      }
    },
    created() {
      this.resetSortField();

      if (!moduleNews.isRegistered) {
        this.$store.registerModule('news', moduleNews)
        moduleNews.isRegistered = true
      }
      
      this.fetchData();
      this.fetchMainNews();
      this.fetchHighlightedNews();
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
#custom-table-list {
  .vs-card--header {
    box-shadow: none !important;
  }

  .header-table {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.con-vs-tooltip {
  display: inline-block !important;
}
</style>